// extracted by mini-css-extract-plugin
module.exports = {"container":"HowItWorksStep_container__jlTpk","icon":"HowItWorksStep_icon__y57MJ","content":"HowItWorksStep_content__BQ5Uf","title":"HowItWorksStep_title__jxvt_"};